import {
  getXeroAuthorizationCallbackURL,
  getXeroAuthorizationURL,
  getXeroOrganisationsURL,
  getXeroRefreshURL,
  getXeroSyncInvoiceURL,
  getXeroWritebackAccountsUrl
} from "../utils/constants/apiEndPoints";
import { useParams } from "react-router-dom";
import privateAxios from "../utils/axiosPrivate";
const useXeroApi = () => {
  const { id } = useParams();

  const XeroAuthorize = async () => {
    const response = await privateAxios.get(getXeroAuthorizationURL);
    return response;
  };

  const XeroCallBack = async (bodyObj = {}) => {
    const response = await privateAxios.get(
      getXeroAuthorizationCallbackURL(bodyObj.code)
    );
    return response;
  };

  const XeroRefresh = async () => {
    const response = await privateAxios.get(getXeroRefreshURL);
    return response;
  };

  const CustomerdetailsXeroRefresh = async () => {
    const response = await privateAxios.get(getXeroOrganisationsURL, {
      params: {
        userAccountId: id
      }
    });
    return response;
  };

  const XeroSyncInvoice = async () => {
    return privateAxios.post(getXeroSyncInvoiceURL);
  };

  const XeroGetWritebackAccounts = async () => {
    const response = await privateAxios.get(getXeroWritebackAccountsUrl);
    return response;
  };

  const XeroUpdateWritebackAccounts = async (payload) => {
    const response = await privateAxios.put(
      getXeroWritebackAccountsUrl,
      payload
    );
    return response;
  };

  return {
    XeroAuthorize,
    XeroCallBack,
    XeroRefresh,
    XeroSyncInvoice,
    CustomerdetailsXeroRefresh,
    XeroGetWritebackAccounts,
    XeroUpdateWritebackAccounts
  };
};

export default useXeroApi;
